module.exports = {"140681001":"云东街道","140681002":"云中街道","140681003":"云西街道","140681101":"吴家窑镇","140681102":"金沙滩镇","140681103":"毛家皂镇","140681200":"何家堡乡","140681201":"新家园乡","140681202":"亲和乡","140681203":"海北头乡","140681205":"河头乡","140681500":"金沙滩农牧场","140681501":"金沙滩林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140681.json
// module id = 408
// module chunks = 0